import React, { Component } from 'react';
import HeaderBack from '../components/HeaderBack';
import AccountMapContainer from './components/AccountMapContainer';

class MapHolder extends Component {

  render() {
    return (
      <div className="content" style={{padding: 0}}>
        <HeaderBack link="routes.url.accountPlaces" locale={this.props.locale} />
        <div className="map-places-mobile">
          <AccountMapContainer />
        </div>
      </div>
    );
  }
}

export default MapHolder;
